import Box from "@mui/material/Box"
import Container from "@mui/material/Container"
import Typography from "@mui/material/Typography"
import { styled } from "@mui/material/styles"

import Column from "./Column"
import { BLOCK_AFTER_STYLES } from "./Footer"
import Row from "./Row"

export default function LegalPage({ title, children }) {
  return (
    <Column sx={{ gap: 4 }}>
      <HeaderRow>
        <Typography variant="h1">{title}</Typography>
      </HeaderRow>
      <Container>
        <Column sx={{ gap: 1, ...BLOCK_AFTER_STYLES }}>{children}</Column>
      </Container>
    </Column>
  )
}

const HeaderRow = styled(Row)(({ theme }) => ({
  justifyContent: "center",
  alignItems: "center",
  color: "white",
  background: theme.palette.primary.main,
  height: "240px",
  [theme.breakpoints.only("xs")]: {
    height: "200px",
  },
}))

export const SectionTitleTypography = styled((props) => (
  <Typography variant="h3" {...props} />
))(({ theme }) => ({
  marginTop: theme.spacing(1),
}))

export const SectionSubtitleTypography = styled((props) => (
  <SectionTitleTypography variant="h4" {...props} />
))(() => ({}))

export const TermTypography = styled(Typography)(({ theme }) => ({
  fontSize: "1em",
  color: theme.palette.text.secondary,
}))

export const OrderedList = styled((props) => <Box component="ol" {...props} />)(
  ({ theme }) => ({
    paddingInlineStart: "24px",
    marginBlock: 0,
    "& li:nth-child(n + 2)": {
      marginTop: theme.spacing(1),
    },
  })
)

export const UnorderedList = styled((props) => (
  <OrderedList component="ul" {...props} />
))(() => ({}))
